import { Component, Host, Element, Prop, h, Event, EventEmitter } from "@stencil/core";

import { StzhImagecomparisonChangeEvent } from "../../index";

import { StzhImagecomparisonLocalizedText } from "./stzh-imagecomparison.localization";

/**
 * @slot image-before - Slot for a before image
 * @slot image-after - Slot for a after image
 * @slot hint-left - Slot for a left image hint as alternative for attribute
 * @slot hint-right - Slot for a right image hint as alternative for attribute
 */

@Component({
  tag: "stzh-imagecomparison",
  styleUrl: "stzh-imagecomparison.scss",
  scoped: true,
})
export class StzhImageComparison {
  /**  Translation strings. */
  @Prop() localization: StzhImagecomparisonLocalizedText;

  /** Hint left */
  @Prop() hintLeft: string = "";

  /** Hint right */
  @Prop() hintRight: string = "";

  /** Width of image before */
  @Prop({ mutable: true }) value: number = 50;

  /** Overwrite default label */
  @Prop() label: string;

  /** Id for element which describes the label */
  @Prop({ attribute: "a11y-describedby" }) a11yDescribedby: string = "";

  @Element() element: HTMLStzhImagecomparisonElement;

  /* Image comparison slider on change event */
  @Event() stzhChange: EventEmitter<StzhImagecomparisonChangeEvent>;

  private inputElement: HTMLInputElement;

  private handleInput = (event: InputEvent) => {
    let value = this.inputElement.value;
    this.value = Number(value);

    this.stzhChange.emit({
      component: "stzh-imagecomparison",
      originalEvent: event,
      value: this.value,
    });
  };

  async componentWillLoad() {
    if (!this.localization) {
      this.localization = await window.stzhComponents.utils.fetchTranslations(this.element, "imagecomparison");
    }
  }

  render() {
    const classes = {
      "stzh-imagecomparison": true,
    };

    return (
      <Host
        aria-roledescription={this.localization.label}
        style={{
          "--exposure": `${this.value.toString()}%`,
        }}
      >
        <div class={classes}>
          <div class="stzh-imagecomparison__element">
            <slot name="image-before"></slot>
            <slot name="image-after"></slot>

            <label
              class="stzh-imagecomparison__label"
              aria-label={this.label || this.localization.label}
              aria-describedby={this.a11yDescribedby || null}
            >
              <div class="stzh-imagecomparison__slider-icon-wrapper">
                <stzh-icon class="stzh-imagecomparison__slider-icon-left" name="angle-left"></stzh-icon>
                <stzh-icon class="stzh-imagecomparison__slider-icon-right" name="angle-right"></stzh-icon>
              </div>
              <div class="stzh-imagecomparison__slider-line"></div>

              <input
                type="range"
                class="stzh-imagecomparison__control"
                min="0"
                max="100"
                ref={el => (this.inputElement = el as HTMLInputElement)}
                onInput={this.handleInput}
              />
            </label>

            <div class="stzh-imagecomparison__hint-wrapper">
              <span class="stzh-imagecomparison__hint-left">
                {this.hintLeft ? this.hintLeft : <slot name="hint-left"></slot>}
              </span>
              <span class="stzh-imagecomparison__hint-right">
                {this.hintRight ? this.hintRight : <slot name="hint-right"></slot>}
              </span>
            </div>
          </div>
        </div>
      </Host>
    );
  }
}
